$ = require 'jquery'
Accounts = require 'common/lib/accounts'
ApiError = require 'network/api-error'
Auth = require 'db/auth'
CancelFlowComponent = require 'views/billing/cancel-flow-component'
ChangeOrgVisibilityView = require 'views/organization/change-org-visibility-view'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
DeleteOrgButtonComponent = require 'views/organization/delete-org-button-component'
localizeServerError = require 'lib/localize-server-error'
logError = require 'debug/log-error'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
OrgAccountComponent = require 'views/organization/organization-account-component'
OrgFeatures = require 'data/org-features'
OrganizationAllowNonOrgBoardInvitesView = require 'views/organization/organization-allow-non-org-board-invites-view'
OrganizationRestrictBoardVisibilityView = require 'views/organization/organization-restrict-board-visibility-view'
OrganizationRestrictInvitesView = require 'views/organization/organization-restrict-invites-view'
OrganizationRestrictSlackLinkingView = require 'views/organization/organization-restrict-slack-linking-view'
OrganizationView = require 'views/organization/organization-view'
PaidAccount = require 'network/paid-account'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
Util = require 'lib/util'
_ = require 'underscore'
track = require 'debug/track'
l = require 'lib/localize'
t = require('views/internal/recup-with-helpers')('org_account')
f = require 'effing'
ClientConfig = require 'debug/client-config'

module.exports = class OrganizationAccountView extends OrganizationView
  initialize: ->
    super

    @listenTo @model, 'change:prefs', @renderMainContent
    @listenTo @model, 'change:slack-association', @renderMainContent

    if @model.getEnterprise()?
      @listenTo @model.getEnterprise(), 'change:organizationPrefs', @renderMainContent

    return

  renderMainContent: ->
    @$reactRoot ?= $('<div></div>')
    @$('.js-content').append(@$reactRoot)
    @renderReactSection()

    @setActiveView('.js-org-account')

    @

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      t.render =>
        t.div =>
          t.addElement @getOrgAccountComponent()
          if @model.owned()
            if @model.isPremium() && !Accounts.willExpire(@model.get('paidAccount'))
              t.addElement @orgBCDelete()
            else
              t.createElement DeleteOrgButtonComponent,
                onClick: f(@, 'orgDeleteConfirm')


  getOrgAccountComponent: ->
    props =
      isAdmin: @model.owned()
      slackAssociation: @model.getLatestSlackAssociation()
      prefsEnabled: @model.isFeatureEnabled('prefs')
      hasBC: @model.isPremium()
      hasEnterprise: @hasEnterprise()
      visibility: @model.getPermLevel()
      billingUrl: Controller.getOrganizationBillingUrl(@model)
      upsellEnabled: !ClientConfig.get('dontUpsell')
      changeSlackSelfJoin: @model.changeSlackSelfJoin.bind(@model)
      deleteSlackAssociation: @model.deleteSlackAssociation.bind(@model)
      inviteRestrictions: @model.get('prefs').orgInviteRestrict ? []
      boardVisibilityRestrictions: @model.get('prefs').boardVisibilityRestrict
      externalMembersDisabled: @model.get('prefs').externalMembersDisabled
      team: @model
      currentMember: Auth.me()
      openChangeOrgVis: @openChangeOrgVis.bind(@)
      openChangeOrgInviteRestrictions: @openChangeOrgInviteRestrictions.bind(@)
      openChangeBoardVisRestrictions: @openChangeBoardVisRestrictions.bind(@)
      openChangeNonOrgMemberBoardInvites: @openChangeNonOrgMemberBoardInvites.bind(@)
      openChangeSlackRestrictions: @openChangeSlackRestrictions.bind(@)

    @model.ensureSlackAssociation()

    React.createElement OrgAccountComponent, props

  hasEnterprise: ->
    # Two other ways someone can 'belong' to an enterprise is if they:
    #
    # - have SAML credentials for an enterprise, but don't belong to a team
    # - belong to a board that is in an enterprise-owned team, but they don't
    # belong to the team itself
    #
    # Neither of these scenarios apply here because: as they don't belong to a
    # team, they can't see this team page!
    Auth.me().enterpriseList.length != 0

  openChangeOrgVis: (el) ->
    PopOver.toggle
      elem: el
      view: new ChangeOrgVisibilityView({ @model, @modelCache })

    track("Organization View", "Settings Page", "Open Change Org Visibility")

    return

  openChangeOrgInviteRestrictions: (el) ->
    PopOver.toggle
      elem: el
      view: new OrganizationRestrictInvitesView({ @model, @modelCache })

    track("Organization View", "Settings Page", "Open Restrict Org Invites by Email Domain")
    return

  openChangeNonOrgMemberBoardInvites: (el) ->
    PopOver.toggle
      elem: el
      view: new OrganizationAllowNonOrgBoardInvitesView({ @model, @modelCache })

    track("Organization View", "Settings Page", "Toggle Allow Inviting Non-Org Members to Boards")

    return

  openChangeSlackRestrictions: (el) ->
    PopOver.toggle
      elem: el
      view: new OrganizationRestrictSlackLinkingView({ @model, @modelCache })

    track("Organization View", "Settings Page", "Toggle Slack Team Linking Restrictions")

    return

  openChangeBoardVisRestrictions: (el) ->
    PopOver.toggle
      elem: el
      view: new OrganizationRestrictBoardVisibilityView({ @model, @modelCache })

    track("Organization View", "Settings Page", "Open Change Board Visibility")

    return

  bcAdLink: ->
    track("Organization View", "Settings Page", "Inline Business Class Ad Link")

  orgBCDelete: ->
    track("Organization View", "Settings Page", "Open Delete Org Dialog")

    deleteOrg = =>
      new Promise (resolve, reject) =>
        @model.destroy
          success: ->
            track("Organization", "Successfully Delete")
            resolve()
          error: (org, xhr) ->
            reject(ApiError.fromResponse(xhr.status, localizeServerError(xhr)))
      .then ->
        Controller.navigate "/", { trigger: true }
    track("Organization View", "Settings Page", "Open Cancel Business Class and Delete Team Dialog")
    React.createElement CancelFlowComponent,
      key: 'cancel bc'
      type: 'bc'
      isDeleting: true
      productName: l 'products.bc'
      id: @model.id
      paysWithPurchaseOrder: @model.paysWithPurchaseOrder()
      belongsToRealEnterprise: @model.belongsToRealEnterprise()
      cancelProduct: (cancellationInfo) =>
        if cancellationInfo
          { reason, details } = cancellationInfo

        if @model.paysWithPurchaseOrder()
          deleteOrg()
        else
          PaidAccount
            .cancel(@model)
            .then (res) =>
              track("Organization", "Successfully Canceled Paid Account")
              @model.set(res)
            .catch (err) ->
              # If we couldn't cancel BC, we can still try to delete the
              # team
              logError(err)
            .then ->
              deleteOrg()

  orgDeleteConfirm: (el) ->
    track("Organization View", "Settings Page", "Open Delete Org Dialog")

    deleteOrg = =>
      new Promise (resolve, reject) =>
        @model.destroy
          success: ->
            track("Organization", "Successfully Delete")
            resolve()
          error: (org, xhr) ->
            reject(ApiError.fromResponse(xhr.status, localizeServerError(xhr)))
      .then ->
        PopOver.hide()
        Controller.navigate "/", { trigger: true }

    if @model.isPremium() && !Accounts.willExpire(@model.get('paidAccount'))
      # If they have BC, we have to cancel that first
      track("Organization View", "Settings Page", "Open Cancel Business Class and Delete Team Dialog")
      PopOver.toggle
        elem: el
        getViewTitle: -> l(['view title', 'delete team'])
        maxWidth: 600
        reactElement: React.createElement CancelFlowComponent,
          key: 'cancel bc'
          type: 'bc'
          initialIsCancelling: true
          isDeleting: true
          productName: l 'products.bc'
          cancelProduct: ({ reason, details }) =>
            if @model.paysWithPurchaseOrder()
              deleteOrg()
            else
              PaidAccount.cancel(@model)
              .then (res) =>
                track("Organization", "Successfully Canceled Paid Account")
                @model.set(res)
              .catch (err) =>
                # If we couldn't cancel BC, we can still try to delete the
                # team
                logError(err)
              .then =>
                deleteOrg()
    else
      Confirm.toggle 'delete organization',
        elem: el
        model: @model
        confirmBtnClass: 'negate'
        fxConfirm: (e) =>
          deleteOrg()
          .done()
    return

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-account-view.coffee